import { render, staticRenderFns } from "./messageviewattachments.vue?vue&type=template&id=53af5e14&"
import script from "./messageviewattachments.vue?vue&type=script&lang=ts&"
export * from "./messageviewattachments.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports